// Centralized Worker URL — change this if you self-host the Worker.
export const WORKER_BASE = "https://cors.media.portalheaven.stream";

export interface WorkerFetchOpts {
  timeoutMs?: number;
}

export async function workerFetch(path: string, opts: WorkerFetchOpts = {}): Promise<Response> {
  const url = `${WORKER_BASE}${path}`;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), opts.timeoutMs ?? 15000);
  try {
    return await fetch(url, { signal: controller.signal });
  } finally {
    clearTimeout(timer);
  }
}
